import { cn } from "@/lib/utils";
import { useOrdersStore } from "./use-orders-store";
import { Order } from "@/types/supabase";
import { Badge } from "@/components/atoms/badge";

type OrderStatus = "all" | Order["status"];

export default function OrderStatusFilter() {
  const statusFilter = useOrdersStore((state) => state.statusFilter);
  const setStatusFilter = useOrdersStore((state) => state.setStatusFilter);
  const ordersCount = useOrdersStore((state) => state.ordersCount);

  const statuses: OrderStatus[] = [
    "all",
    "pending",
    "accepted",
    "sorted",
    "in_transit",
    "on_site",
    "completed",
    "cancelled",
  ];

  const translation = {
    all: "Todas",
    pending: "En cola",
    accepted: "Asignadas",
    sorted: "Surtidas",
    in_transit: "En tránsito",
    on_site: "En sitio",
    completed: "Completadas",
    cancelled: "Canceladas",
  };

  return (
    <div className="flex items-end gap-0 p-4 pb-0 bg-white overflow-x-auto">
      {statuses.map((status: OrderStatus, index: number) => (
        <button
          key={index}
          type="button"
          onClick={() => setStatusFilter(status)}
          className={cn(
            "text-sm font-normal text-gray-500 border-b-2 border-transparent px-3 py-1 hover:border-gray-500 hover:text-gray-800 flex items-center gap-2 shrink-0",
            statusFilter === status && "border-indigo-500 text-gray-800",
          )}
        >
          {translation[status as keyof typeof translation]}
          <Badge variant="secondary" className="text-xs">
            {status === "all" && `${ordersCount.all}`}
            {status !== "all" && `${ordersCount[status] || 0}`}
          </Badge>
        </button>
      ))}
    </div>
  );
}
